import React from "react";

const SvgEmptyMarkerB2 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 26" ref={svgRef} {...props} width="1em" height="1em">
    <title>{title}</title>
    <path
      d="M8.9.4C4.1.4.3 4.4.3 9.2c0 6.6 8.6 16.4 8.6 16.4s8.6-9.8 8.6-16.4C17.6 4.4 13.7.4 8.9.4"
      fill="#2fa0a0"
    />
    <path
      d="M4.7 4.4h4.9c1.1 0 2.1.3 2.7.8.7.6 1 1.3 1 2.1 0 1.3-.7 2.1-2.2 2.6.8.1 1.4.4 1.8.9.4.5.7 1.1.7 1.8 0 .9-.3 1.6-1 2.1s-1.6.8-2.7.8H4.7V4.4zm2.8 2.1V9h1.8c.4 0 .7-.1 1-.3s.4-.5.4-.9-.3-.8-.5-1c-.2-.2-.6-.3-1-.3H7.5zm0 7.1h2.1c.4 0 .7-.1.9-.3.2-.2.4-.5.4-.9s-.1-.7-.4-.9c-.3-.3-.6-.5-.9-.5H7.5v2.6z"
      fill="#fff"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgEmptyMarkerB2 svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/EmptyMarkerB2.js